<template>
  <v-container id="app-resto-flash">
    <screen
      :title="$t('field.trx_code')"
      :info="code"
    />

    <keyboard-code
      v-model="code"
      @cancel="cancel"
      @valid="valid"
    />
  </v-container>
</template>

<script>
import { Scan } from '../../modules/Scan'
import { $alert } from '@/modules/Utils'

export default {
  name: 'RestoFlashView',

  props: {
    action: { type: Number, default: null }
  },

  data () {
    return {
      code: ''
    }
  },

  mounted () {
    if (this.action === null) {
      this.$router.replace('/')
    }
  },

  methods: {
    cancel () {
      this.$router.replace('/home')
    },
    valid () {
      if (this.code !== '') {
        Scan.restoflashPayment(this.code, (error) => {
          this.code = ''
          $alert(error)
        })
      }
    }
  }
}
</script>
